<template>
    <!-- begin panel -->
    <panel  :title="nuevo ? 'Registrar Nueva Entrega de Equipo':'Editar Entrega de Equipo'" panelClass="panel-with-tabs"
        variant="default" ref="header" noButton="false">
        <form v-show="!proceso" action="/" method="POST">
            <fieldset>
                <div class="row">
                    <div class=" col-xl-2 col-lg-2">
                        <div class="form-group">
                            <label>IMEI</label>
                            <input type="text" maxlength="15" data-vv-name="IMEI" v-validate="'required|numeric|min:15'" v-model="entregaEquipo.imei" placeholder="Ingrese el IMEI"
                                class="form-control">
                                 <error :attribute_name="'IMEI'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-3 col-lg-3">
                        <div class="form-group">
                            <label>Modelo</label>
                            <input type="text"  maxlength="30"  data-vv-name="modelo" v-validate="'required'" v-model="entregaEquipo.modelo" placeholder="Ingrese el modelo del equipo"
                                class="form-control">
                                 <error :attribute_name="'modelo'" :errors_form="errors" />
                        </div>
                    </div>
                    <div class=" col-xl-2 col-lg-2">
                        <div class="form-group">
                            <label>Precio</label>
                            <input type="text"  maxlength="7"  data-vv-name="precio" v-validate="'required|decimal:2'" v-model="entregaEquipo.precio_base" placeholder="Ingrese el precio"
                                class="form-control">
                                 <error :attribute_name="'precio'" :errors_form="errors" />
                        </div>
                    </div>
                
                    <div v-show="entregaEquipo.vendedor!=''" class=" col-xl-4 col-lg-4">
                        <div class="form-group">
                            <label>Vendedor</label>
                            <input ref="vendedor" type="text" readonly class="form-control" v-model="entregaEquipo.vendedor">
                        </div>
                    </div>
                    <div v-show="entregaEquipo.vendedor!=''" class=" col-xl-1 col-lg-1">
                        <div class="form-group">
                            <label>Quitar</label> <br>
                            <button type="button" @click="entregaEquipo.vendedor=''" class="btn btn-danger">x</button>
                        </div>
                    </div>
                    <div v-show="entregaEquipo.vendedor==''" class=" col-xl-5 col-lg-5">
                        <div class="form-group">
                            <label>Vendedor</label>
                            <vueSelect 
                            class="animated fadeIn"
                             data-vv-name="vendedor" 
                             v-validate="'required_if:vendedor,'"
                            :multiple="false"
                            :filterable="false"
                            :placeholder="'Buscar vendedor'"
                            :source="URL_BASE()+'personal/read/'"
                            :method="'post'"
                            :label="'vendedor'"
                            @selected="buscar($event)"
                            /> 
                        <error :attribute_name="'vendedor'" :errors_form="errors" />
                        </div>
                    </div>
                   
                </div>
                <hr>
              
               
                <div class="row">
                    <div class=" offset-xl-10 offset-lg-8  offset-md-8 col-xl-1  col-lg-2  col-md-2 text-center">
                        <button type="button" @click="$emit('cancelar')" class="btn btn-default btn-sm btn-circle  btn-block"> <i
                                class="fa fa-times "></i> CANCELAR </button>
                    </div>

                   
                    <div class="  col-xl-1 col-lg-2 col-md-2  text-center">
                        <button v-if="nuevo" type="button" @click="validarFormulario('guardar')"
                            class="btn btn-primary btn-sm  btn-block"> <i class="fa fa-save "></i> GUARDAR </button>
                        <button v-else type="button" @click="validarFormulario('actualizar')"
                            class="btn btn-info btn-sm btn-circle  btn-block"> <i class="fa fa-save "></i> EDITAR </button>
                    </div>

                </div>
                

            </fieldset>
        </form>

        <div class="row" v-show="proceso">
            <div class="col-lg-12 text-center">
                <h4>Espere por favor, se está verificando <i class="fa fa-spinner fa-spin fa-lg"></i> </h4>
            </div>
        </div>

    </panel>
    <!-- end panel -->
</template>

<script>
    import error from '../Error'
    import vueSelect from '../VueSelect'
    import axios from 'axios'
    export default {
        name: 'entregaEquipoComponent',
        props: ['registro', 'nuevo'],
        components: {
            error,
            vueSelect
        },
        data() {
            return {
                //0: POR VERIFICAR, 1: SIN REPETIDOS, 2: REPETIDOS
                verificar_rango_chip:0,
                proceso:false,
                data: [],
                iniciar_autocompletado: false,
                personal_defecto:'',
                entregaEquipo: {
                    imei: "",
                    modelo: "",
                    dni_admin: "",
                    dni_vendedor: "",
                    vendedor: "",
                    precio_base: "",
                    dni_vendedor_editar:""
                },
            }
        },
        created() {

            setTimeout(() => {
                this.iniciar_autocompletado = true;
            }, 100);

        },
        beforeMount() {
            if (!this.nuevo) {
                this.entregaEquipo = {
                    ...this.registro
                };
            } else {
                this.limpiar();
            }
        },
        methods: {
            // verificarChip(){

            //     this.$validator.validateAll().then((result) => {
            //         if(result){
            //             this.proceso=true;
            //         axios.post(this.URL_BASE()+"entrega_equipo_vendedor/verificar_rango/",this.entregaEquipo).then(respuesta => {
            //         //   console.log(respuesta.data.msg)
            //             if(respuesta.data.msg=='exito'){
            //                 // this.exito("Comisión registrada correctamente");
            //                 this.entregaEquipo.cantidad=respuesta.data.data[0]['cantidad'];
            //                 this.entregaEquipo.chip_registrados=respuesta.data.data[0]['chip_registrados'];
            //                 if(this.entregaEquipo.chip_registrados>0){
            //                     this.verificar_rango_chip=2;
            //                 }else{
            //                     this.verificar_rango_chip=1;
            //                 }

            //                 if(this.entregaEquipo.cantidad<0){
            //                     this.verificar_rango_chip=2;
            //                 }
            //             }
            //             this.proceso=false;
            //         }).catch(function (error) {
            //         console.log("er store"+error);
            //         });
            //     }
            // });
			// },
            validarFormulario(tipo){

                this.$validator.validateAll().then((result) => {
                     this.entregaEquipo.dni_admin=this.$store.state.usuario.dni;
                    if (result) {
                        if(tipo=='guardar'){
                           
                            this.$emit('guardar',this.entregaEquipo);
                        }else{
                            this.$emit('actualizar',this.entregaEquipo);
                            setTimeout(() => {
                                this.$emit('cancelar');
                            }, 250);
                            
                        }
                        return;
                    }
                });
            },
            opcionSeleccionada(seleccion) {
                this.entregaEquipo.emisor_id = seleccion.id;
            },
            limpiar() {
                this.entregaEquipo.entregaEquipo = "";
                this.entregaEquipo.emisor_id = "";
                this.entregaEquipo.emisor = "";
                this.entregaEquipo.estado = "1";
            },
            buscar(vendedor){
                this.entregaEquipo.dni_vendedor=vendedor.dni;
            }

        }
    }
</script>